<header class="d-flex justify-content-center p-3">
    <a href="javascript:void(0)" (click)="goToHome()">
        <img src="assets/intake-logo.png" />
    </a>
</header>